export const errors = {
  NETWORK_ERROR:
    "The Tax Portal cannot reach the API service at this time. Please contact your payroll support.",
  ERRCODE: { CID: "ID-C1", PID: "ID-P1", ROLE: "ID-R1" },
  REASONCODE: { CID: "Client ID", PID: "Processor ID", ROLE: "Role" },
  GENERALERRMESSAGE: ": Identity Profile incomplete, ",
  ENDINGERRMSG: " is missing.Please contact your payroll support.",
};
